import { render, staticRenderFns } from "./HomeModule.vue?vue&type=template&id=4acc732a"
import script from "./HomeModule.vue?vue&type=script&lang=js"
export * from "./HomeModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports